import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '@terminal/routes/query-params';
import React from 'react';

import { useMarketInsightsStore } from '../../hooks/useMarketInsightsStore';
import { MarketInsightDrawer } from './MarketInsightDrawer';

export const MarketInsightDrawerRender = () => {
  const { params } = useQueryParams();
  const activeDrawer = params[queryKeys.activeDrawer];
  const activeDate = params[queryKeys.activeDate];
  const { getActiveMarketInsightsGroup } = useMarketInsightsStore(state => ({
    getActiveMarketInsightsGroup: state.getActiveMarketInsightsGroup,
  }));

  const activeInsightsGroup = activeDate
    ? getActiveMarketInsightsGroup(activeDate?.split('T')[0]) ?? []
    : null;

  if (
    activeDrawer === queryValues.marketInsightDrawer &&
    !!activeInsightsGroup?.length
  ) {
    return (
      <ErrorBoundaryWrapper showBorder={false}>
        <MarketInsightDrawer activeInsightsGroup={activeInsightsGroup} />
      </ErrorBoundaryWrapper>
    );
  }

  return null;
};
